import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import {getFormattedCode} from "../../../utils/post-utils";

function SimpleCode(props: Props) {
  return (
    <div className={'simple-code'}>
      <SyntaxHighlighter language={props.language} style={dracula}>
        {getFormattedCode(props.language, props.content)}
      </SyntaxHighlighter>
    </div>
  )
}

export default SimpleCode;

class Props {
  language: string;

  content: string;
}
